export default __webpack_public_path__ + "static/media/sketch04.aa8a2585.jpg";